import { render, staticRenderFns } from "./OcrWidget.vue?vue&type=template&id=af2c5e96&scoped=true&"
import script from "./OcrWidget.vue?vue&type=script&lang=js&"
export * from "./OcrWidget.vue?vue&type=script&lang=js&"
import style0 from "./OcrWidget.vue?vue&type=style&index=0&id=af2c5e96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2c5e96",
  null
  
)

export default component.exports